module.exports = __webpack_public_path__ + "static/media/gov_white.f44768da.png";